import { Component,Input } from '@angular/core';
// import { Component, Input, ViewChild } from '@angular/core';
/**
 * Generated class for the RmtSkeletonTransactionComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'rmt-skeleton-transaction',
  templateUrl: 'rmt-skeleton-transaction.html'
})
export class RmtSkeletonTransactionComponent {
  @Input() isReady: boolean = false;
  @Input() lines = 6;
  @Input() subtitles = 1;
  @Input() padding = true;

  linesFor = [];
  subtitlesFor = [];

  constructor() {

  }

  ngAfterViewInit() {
    this.linesFor = [];
    for (let i=0; i < this.lines; i++) {
      this.linesFor.push(i);
    }
    this.subtitlesFor = [];
    for (let i=0; i < this.subtitles; i++) {
      this.subtitlesFor.push(i);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-skeleton-transaction/rmt-skeleton-transaction.ts